import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import { loadCablePdfFromServer, uploadCablePdf, deleteCablePdf } from '../../FileResources/CableFotoPdf/ServiceUtilitiesCableFotoPdf';

const DialogCablePdfEditing = ({open, onClose, id, user}) => {
 
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [uploadMessage, setUploadMessage] = useState('');
  const [serverPdfUrls, setServerPdfUrls] = useState([]); // Изменено с serverImageUrls на serverPdfUrls
  const [selectedPdf, setSelectedPdf] = useState(null); // Изменено с selectedImage на selectedPdf
  const [selectedFileType, setSelectedFileType] = useState(null);

  // Открытие модального окна для PDF
  const handlePdfClick = (url, fileType) => {
    setSelectedPdf(url);
    setSelectedFileType(fileType.includes("image") ? "image" : "pdf");
  };

  // Закрытие модального окна
  const closeModal = () => {
    setSelectedPdf(null);
    setSelectedFileType(null);
  };

  // Обработка выбора файла
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  //Обработка удаления изображения
  const handleDelete = async (fileName) => {
    await deleteCablePdf(fileName, id, setServerPdfUrls, setUploadMessage);
  };

  // Обработка загрузки файла
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      await uploadCablePdf(file, id, setFileName, setIsFileUploaded, setServerPdfUrls, setUploadMessage, user);
    }
  };

  // Загружать PDF при старте страницы
  useEffect(() => {
    loadCablePdfFromServer(id, setServerPdfUrls, setUploadMessage);
  }, []); // Пустой массив зависимостей, чтобы загрузка выполнялась только при монтировании
 
  
    return (
      <Dialog open={open} className="modalStyleFoto" fullWidth maxWidth="md"> 
      <DialogContent>
      <div className='divFotoRes' style={{ width: '100%', height: '100%', paddingRight: '10px' }}>       
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование файлов</label>
        <br/>
       <button className='buttonIsHideModal' style={{width: '200px'}} onClick={handleButtonClick}>
          Загрузить PDF / image
      </button>
      {/* <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept="application/pdf"
      /> */}
      <input
  type="file"
  ref={fileInputRef}
  style={{ display: 'none' }}
  onChange={handleFileChange}
  accept="application/pdf, image/png, image/jpeg"
/>
      {isFileUploaded && (
        <div>
           <label style={{ color: '#fad46b', fontWeight: 'bold'}}>Имя файла: <span style={{ color: '#bebebe',fontWeight: 'normal' }}>{fileName}</span> </label>
           <br/>
           {/* <label style={{ color: '#92ab87',fontWeight: 'normal' }}>Файл загружен</label> */}
        </div>
      )}
              <hr className='horizontalLineDialog'/>
    {serverPdfUrls.length > 0 && (
      <div style={{ overflow: 'hidden' }}>
      {serverPdfUrls.map((pdf, index) => (
        <div key={index} style={{ marginTop: '10px', maxWidth: '100%', overflow: 'hidden' }}>
          <button
                style={{
                  cursor: 'pointer',
                  display: 'block',
                  width: '100%',
                  borderRadius: '10px',
                  maxWidth: 'calc(100% - 20px)', 
                  margin: '0 auto', 
                  padding: '10px', 
                  boxSizing: 'border-box',
                  textOverflow: 'ellipsis', 
                  overflow: 'hidden', 
                  background: 'linear-gradient(45deg, #f0d47f,#f5cb4e )', 
                  transition: 'background 0.3s ease', 
                }}
                onClick={() => handlePdfClick(pdf.url, pdf.type)} 
                onMouseOver={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #d2f7a3, #abe861)'} 
                onMouseOut={(e) => e.currentTarget.style.background = 'linear-gradient(45deg, #f0d47f, #f5cb4e)'} 
              >
                <span style={{ color: '#666665', fontWeight: 'bold' }}>Открыть {pdf.fileName.split('.').pop().toUpperCase()}: </span>
                <hr className='horizontalLineDialog' />
                {pdf.fileName}
              </button>
              <button className='buttonIsDeleteModal'style={{width: '150px', marginLeft: '10px', padding: '0px'}} onClick={() => handleDelete(pdf.fileName)}>Удалить</button>
              <hr className='horizontalLineDialog' />
        </div>
      ))}
      </div>
)}
    {uploadMessage && <p>{uploadMessage}</p>}

    {/* Модальное окно для просмотра PDF */}
    {selectedPdf && (
      <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
      onClick={closeModal} // Закрытие модального окна при клике
    >
      {selectedFileType === 'pdf' ? (
        <embed
          src={selectedPdf}
          type="application/pdf"
          width="90%"
          height="90%"
          style={{ backgroundColor: '#fff' }}
        />
      ) : (
        <div style={{ width: '70%', height: '90%', overflow: 'auto', backgroundColor: '#fff' }}>
        <img
        src={selectedPdf}
        alt="Просмотр файла"
        style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight: 'none' }}
      />
      </div>
      )}
    </div>
  )}
  </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogCablePdfEditing;